import { render } from "./CorteDiarioView.vue?vue&type=template&id=2f30095c"
import script from "./CorteDiarioView.vue?vue&type=script&lang=js"
export * from "./CorteDiarioView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\WGitHub\\Kubber\\kubber\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__